__turbopack_context__.v({
  "ring": "kStesa_ring",
  "root": "kStesa_root",
});
